<span class="font-weight-600" [ngClass]="fontSize">What You'll Learn:</span>
@for (skill of skills; track skill) {
  <ul>
    <li [ngClass]="fontSize">
      {{ skill.name }}
    </li>
  </ul>
}
